import PropTypes from "prop-types";
import React from "react";
import Header from "layouts/WebsiteLayout/Header";
import Footer from "layouts/WebsiteLayout/Footer";

import { useLocation } from "react-router-dom";

const WebsiteLayout = ({ children, showHeader = true, showFooter = true }) => {
  const location = useLocation();
  const shouldShowFooter = showFooter || location.state?.showFooter;
  const shouldShowHeader = showHeader || location.state?.showFooter;

  return (
    <div className={`content ${shouldShowFooter ? "has-footer" : ""}`}>
      {shouldShowHeader && <Header />}
      {children}
      {shouldShowFooter && <Footer />}
    </div>
  );
};

WebsiteLayout.propTypes = {
  children: PropTypes.node,
};
export default WebsiteLayout;
